import React from 'react';
import { Box, Stack, TextField } from '@mui/material';
import TopBar from '../../../components/TopBar';
import ProductListPageActions from '../components/ProductListPageActions';
import ProductsTable from '../components/ProductsTable';
import useProductFilters from '../components/ProductFilterHelper';

export default function ProductListPage() {
  const { searchTerm, currentQuery, pagination, handleSearchChange, handleSearchKeyDown, handlePaginationChange } =
    useProductFilters({ defaultQuery: {} });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Products">
        <ProductListPageActions />
      </TopBar>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <TextField
          label="Search by name or description"
          placeholder="Search by name or description"
          value={searchTerm}
          onChange={(event) => handleSearchChange(event.target.value)}
          onKeyDown={handleSearchKeyDown}
          size="small"
          sx={{ width: 320 }}
        />
      </Box>
      <ProductsTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={currentQuery}
        paginationModel={{ page: pagination.page, pageSize: pagination.size }}
      />
    </Stack>
  );
}
